module.exports = __webpack_public_path__ + "static/media/paymentImage.cf6a82a5.png";